// extracted by mini-css-extract-plugin
module.exports = {"aboutUsPageContainer":"about-us-page_aboutUsPageContainer__fovKU"};